export default __webpack_public_path__ + "static/valve_b.0d2f42e77e08d96a7526696d32cdcef5.png";